/** Weighbridge operator sub-pages (Inward / Outward / Register). */
export const WEIGHBRIDGE_MODULES = {
  inward: {
    key: "inward",
    tab: "operations",
    eyebrow: "Weighbridge · Inward",
    title: "Inward Weighment",
    description: "Start purchases from gate passes and record gross, mid, and tare weights for incoming paddy.",
    testId: "weighbridge-inward-page",
  },
  outward: {
    key: "outward",
    tab: "outward",
    eyebrow: "Weighbridge · Outward",
    title: "Outward Weighment",
    description: "Record tare and gross weights for outward rice dispatch vehicles.",
    testId: "weighbridge-outward-page",
  },
  register: {
    key: "register",
    tab: "register",
    eyebrow: "Weighbridge · Register",
    title: "Weighment Register",
    description: "Inward and outward weighment history — review, print slips, photos, and correct weights when needed.",
    testId: "weighbridge-register-page",
  },
};

export function weighbridgeModuleFromKey(key) {
  return WEIGHBRIDGE_MODULES[key] || WEIGHBRIDGE_MODULES.inward;
}
